<div class="production-db-content" dir="{{languageDir}}">
  <div class="content-top-box">
    <app-bread-crumb></app-bread-crumb>
    <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" template=" <img src='assets/images/spinner.gif' />"></ngx-spinner>
  </div>
  <mat-card style="width: 100%;">
    <div>
      <div style="display: flex;">
        <mat-card-title>{{t('NewDefectDashboard', 'NewDefectDashboard')}}</mat-card-title>
        <mat-slide-toggle class="IsMachine" [pTooltip]="IsMachine ? t('WithMachine', 'With Machine') : t('WithoutMachine', 'Without Machine')"
          tooltipPosition="top" [checked]="IsMachine" (change)="onCheckboxChange($event)"></mat-slide-toggle>
      </div>
      <div>
        <form [formGroup]="CLLDashboardForm" (ngSubmit)="onSubmit()">
          <div class="content-row-wrap">
            <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing"
              style="width: 19%;" *ngIf="IsMachine">
              <mat-label>{{t('Department', 'Department')}}</mat-label>
              <mat-select formControlName="Departments" (selectionChange)="onChangeDepartments($event)">
                <mat-select-filter [placeholder]="t('SearchDepartment', 'Search Department')" [displayMember]="'TypeName'"
                  [array]="deparmentList" (filteredReturn)="deparmentFiltList = $event">
                </mat-select-filter>
                <mat-option value="0">{{ t('All', 'All') }}</mat-option>
                <mat-option *ngFor="let dept of deparmentFiltList" [value]="dept.TypeId">
                  {{ dept.TypeName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <!-- GROUP -->
            <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing"
              style="width: 19%;" *ngIf="!IsMachine">
              <mat-label>{{t('Line', 'Line')}} </mat-label>
              <mat-select formControlName="line" panelClass="testClass" name="line"
                (selectionChange)="onChangeLine($event)">
                <mat-select-filter [placeholder]="t('Search', 'Search')" [displayMember]="'PL_Desc'" [array]="lineList"
                  (filteredReturn)="filteredLines = $event"></mat-select-filter>
                <mat-option value="0">{{ t('All', 'All') }}</mat-option>
                <mat-option *ngFor="let line of filteredLines" [value]="line.PL_Id">
                  {{ line.PL_Desc }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing"
              style="width: 19%;" *ngIf="!IsMachine">

              <mat-label>{{t('Unit', 'Unit')}}</mat-label>
              <mat-select formControlName="unit" panelClass="testClass" name="unit"
                (selectionChange)="onChangeUnit($event)">
                <mat-select-filter [placeholder]="t('Search', 'Search')" [displayMember]="'PU_Desc'" [array]="unitList"
                  (filteredReturn)="filteredUnits = $event"></mat-select-filter>
                <mat-option value="0">{{ t('All', 'All') }}</mat-option>
                <mat-option *ngFor="let unit of filteredUnits" [value]="unit.PU_Id">
                  {{ unit.PU_Desc }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <!-- <mat-form-field appearance="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
        <mat-label>Date Range</mat-label>
        <mat-date-range-input [rangePicker]="picker">
          <input
            matStartDate
            formControlName="dateStart"
            placeholder="From Date"
          />
          <input matEndDate formControlName="dateEnd" placeholder="To Date" />
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>     -->

            <div class="inputField" style="width: 20%; margin-left: 10px; margin-top: 15px;">
              <nz-range-picker style="margin-left: 0px !important;" class="calender-input" [nzInputReadOnly]="true"
                [nzShowTime]="{ nzFormat: 'HH:mm' }" nzFormat="dd-MM-yyyy HH:mm" formControlName="datePicker"
                [nzDisabledDate]="disabledDate">>
              </nz-range-picker>
              <span class="floating-text">{{t('DateRange', 'Date Range')}}</span>
            </div>
            <button mat-mini-fab mat-button color="primary" type="submit" [pTooltip]="t('Search', 'Search')" tooltipPosition="top"
              style="margin-left: 10px;margin-top: auto;margin-bottom:auto;">
              <mat-icon>search</mat-icon>
            </button>
          </div>
        </form>
      </div>
    </div>
  </mat-card>
  <!-- chart -->
  <div class="chart-group">
    <div class="chart-items-l" *ngIf="IsMachine">
      <div [chart]="chartDept"></div>
    </div>
    <div class="chart-items-w30-l" *ngIf="IsMachine">
      <div [chart]="chartDeptPercentage"></div>
    </div>
    <div class="chart-items-u" *ngIf="!IsMachine">
      <div [chart]="chartLine"></div>
    </div>
    <div class="chart-items-w30-u" *ngIf="!IsMachine">
      <div [chart]="chartLinePercentage"></div>
    </div>
    <div class="chart-items-u" *ngIf="!IsMachine">
      <div [chart]="chartUnit"></div>
    </div>
    <div class="chart-items-w30-u" *ngIf="!IsMachine">
      <div [chart]="chartUnitPercentage"></div>
    </div>
  </div>
</div>


<!--popup modal for production checklist history-->

<section>

  <div class="import_export">
    <button type="button" (click)="excelExport()" class="export" *ngIf="isAccess | permissionChecker">{{t('DownloadExcelexportfile', 'DownloadExcelexportfile')}}</button>
    <!-- {{t('DownloadExcelexportfile', 'DownloadExcelexportfile')}} -->
  </div>
</section>
<mat-card-content>
  <ag-grid-angular style="width: 100%; height: 24vw;" class="ag-theme-alpine" [rowData]="rowData"
    [defaultExcelExportParams]="defaultExcelExportParams" [frameworkComponents]="frameworkComponents"
    [columnDefs]="columnDefs" (gridReady)="onGridReadyDefect($event)" (cellClicked)="cellClicked($event)"
    [gridOptions]="gridOptions" [pagination]="true" [paginationPageSize]="10">
  </ag-grid-angular>
</mat-card-content>

<ng-template #popupViewModal>
  <div mat-dialog-title>
    <div class="d-flex justify-content-between align-items-center">
      <h2>{{t('ActionView', 'ActionView')}}</h2>
      <button mat-mini-fab mat-button mat-dialog-close color="warn" [title]="t('Close', 'Close')">
        <i class="fa fa-times" style="color: #fff"></i>
      </button>
    </div>
  </div>
  <div>
    <table [dataSource]="actionDataSource" mat-table class="basic-table plant-model-table theight" matSort>
      <!-- Checklist Column -->
      <ng-container matColumnDef="date">
        <th mat-header-cell mat-sort-header-pointer-middle *matHeaderCellDef mat-sort-header>
          <p class="header-text">{{t('TargetDate', 'TargetDate')}}</p>

        </th>
        <td mat-cell *matCellDef="let element">{{element.TargetDate | date : 'medium'}}</td>
      </ng-container>
      <ng-container matColumnDef="newDate">
        <th mat-header-cell mat-sort-header-pointer-middle *matHeaderCellDef mat-sort-header>
          <p class="header-text">{{t('NewTargetDate', 'NewTargetDate')}}</p>
        </th>
        <td mat-cell *matCellDef="let element">{{element.NewTargetDate | date : 'medium'}}</td>
      </ng-container>

      <!-- Values Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <p class="header-text">{{t('ActionName', 'ActionName')}}</p>
        </th>
        <td mat-cell *matCellDef="let element">{{element.Action}}</td>
      </ng-container>

      <!-- Values Column -->
      <ng-container matColumnDef="assignto">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <p class="header-text">{{t('Responsible', 'Responsible')}}</p>
        </th>
        <td mat-cell *matCellDef="let element">{{element.FullName}}</td>
      </ng-container>

      <!-- Values Column -->
      <ng-container matColumnDef="closedate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <p class="header-text">{{t('CompletionDate', 'CompletionDate')}}</p>
        </th>
        <td mat-cell *matCellDef="let element">{{element.CloseDate | date : 'medium'}}</td>
      </ng-container>

      <!-- Values Column -->
      <ng-container matColumnDef="comments">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <p class="header-text">{{t('Remarks', 'Remarks')}}</p>
        </th>
        <td mat-cell *matCellDef="let element">{{element.Remarks}}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      <tr class="mat-row" *matNoDataRow style="text-align: center;">
        <td class="mat-cell" colspan="8">{{t('nodatafound', 'nodatafound')}}</td>
      </tr>
    </table>
  </div>
</ng-template>

<ng-template #imageZoomModel>
  <img [src]="currentImagePath ? this.currentImagePath : 'assets/images/no-image.png' "
    style="height: 98%; width: 100%; overflow: hidden;">
</ng-template>

<ng-template #CloseDefect>
  <div mat-dialog-title>
    <div class="d-flex justify-content-between align-items-center">
      <h2>{{ t('ActionDetail', 'ActionDetail') }}</h2>
      <button mat-mini-fab mat-button mat-dialog-close color="warn" [title]="t('Close', 'Close')">
        <i class="fa fa-times" style="color: #fff"></i>
      </button>
    </div>
  </div>
  <mat-dialog-content style="overflow:unset">
    <form [formGroup]="CloseDefectForm">
      <div class="content-row-wrap" style="justify-content: space-between">
        <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing"
          style="margin-left: 0px; width: 70%;">
          <input type="text" matInput [placeholder]="t('Remarks', 'Remarks')" formControlName="remarks">
        </mat-form-field>
        <img style="height:70px;width:70px" [src]="this.CloseImage ? this.CloseImage : 'assets/images/no-image.png'"
          (click)="imageModal()" />
      </div>
    </form>
  </mat-dialog-content>
</ng-template>

<ng-template #ViewActionDetailModel>
  <div mat-dialog-title>
    <div class="d-flex justify-content-between align-items-center">
      <h2>{{ t('ActionDetail', 'ActionDetail') }}</h2>
      <button mat-mini-fab mat-button mat-dialog-close color="warn" [title]="t('Close', 'Close')">
        <i class="fa fa-times" style="color: #fff"></i>
      </button>
    </div>
  </div>
  <mat-dialog-content>
    <!-- <div class="mat-elevation-z8"> -->
    <ag-grid-angular style="width: 100%; height: 30vw" class="ag-theme-alpine" [rowData]="rowDataViewActions"
      [columnDefs]="columnDefsActionView" [gridOptions]="gridOptionsDefectAction" [enableSorting]="true"
      [pagination]="true" [enableFilter]="true" (cellClicked)="cellClicked($event)" (gridReady)="onGridReady($event)">
    </ag-grid-angular>
    <!-- </div> -->
  </mat-dialog-content>
</ng-template>

<ng-template #imageViewModal>
  <mat-carousel timings="250ms ease-in" [autoplay]="false" interval="5000" color="accent" [loop]="true"
    [hideArrows]="false" [hideIndicators]="false" [useKeyboard]="true" [useMouseWheel]="true" orientation="ltr">
    <mat-carousel-slide #matCarouselSlide *ngFor="let slide of slidesImages; let i = index" [image]="slide"
      overlayColor="#00000040" [hideOverlay]="false"></mat-carousel-slide>
  </mat-carousel>
</ng-template>